<template>
  <v-row justify="center" align="center">
    <v-col cols="12" md="6" lg="5">
      <div id="create" v-if="listingData">
        <v-simple-table>
          <template v-slot:default>
            <tbody>
              <tr>
                <th>Name</th>
                <td>
                  : {{ listingData.firstName }} {{ listingData.lastName }}
                </td>
              </tr>
              <tr>
                <th>TXN ID</th>
                <td>: {{ listingData.txnID }}</td>
              </tr>
              <tr>
                <th>Status</th>
                <th v-if="listingData.status === 'Success'" style="color:green">
                  : {{ listingData.status }}
                </th>
                <th v-else style="color:red">: {{ listingData.status }}</th>
              </tr>
              <tr>
                <th>Transaction Ref.No.</th>
                <td>: {{ listingData.payUID }}</td>
              </tr>
              <tr>
                <th>Transaction Amount</th>
                <td>: Rs. {{ formatNumber(listingData.amount) }}/-</td>
              </tr>
              <tr>
                <th>Transaction Date</th>
                <td>
                  :
                  {{
                    formatDate(listingData.statusDate, "DD-MMM-YYYY hh:mm:ss")
                  }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-data-table
          :mobile-breakpoint="mobilebreakpoint"
          :headers="headers"
          :items="listingData.payDatas"
          :hide-default-footer="true"
          :items-per-page="-1"
          item-key="installmentDate"
          class="elevation-4 mt-2"
        >
          <template v-slot:item.amount="{ item }">
            <span>{{ formatNumber(item.amount) }}</span>
          </template>
          <template v-slot:item.installmentDate="{ item }">
            <span>{{ formatDate(item.installmentDate, "DD-MMM-YY") }}</span>
          </template>
        </v-data-table>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import axios from "axios";
import { get } from "vuex-pathify";
import { formatDate, formatNumber } from "../util/helpers";
import { showSnackbar } from "../util/globalActions";

export default {
  name: "PaymentStatus",

  data: () => ({
    reqRules: [(v) => !!v || "Field is required"],
    validEdit: false,
    listingData: null,
    txnId: "",
    permission: {
      isAdd: false,
      isEdit: false,
      isDelete: false,
      isDownload: false,
    },
    saveLoading: false,
    message: "",
    snackbar: false,
    length: 4,
    tab: null,
    mobilebreakpoint: "200",
    headers: [
      {
        text: "Installment Date",
        value: "installmentDate",
        width: "120px",
        sortable: false,
      },
      {
        text: "Amount",
        value: "amount",
        width: "150px",
        align: "right",
        sortable: false,
      },
    ],
  }),
  created() {},
  mounted() {
    const self = this;
    self.txnId = self.$route.params["txnid"];
    self.showData();
  },
  computed: {
    apiUrl: get("app/apiUrl"),
  },
  watch: {},
  methods: {
    formatNumber,
    formatDate,

    showData() {
      const self = this;

      axios({
        url: self.apiUrl + "api/Fees/PaymentDetails/" + self.txnId,
        method: "GET",
        responseType: "json",
      })
        .then(function(res) {
          self.listingData = res.data;
          console.log(self.listingData);
        })
        .catch(function(err) {
          self.message = err.status;

          showSnackbar({ message: "Data not found!" });
        });
    },
  },
  beforeDestroy() {},
};
</script>
